import React from 'react';
const GlobalPlayerContext = React.createContext({
    props: {},
    showPlayer: (source) => { },
    hidePlayer: () => { }
});
export default GlobalPlayerContext;